module.exports = __webpack_public_path__ + "static/media/token-logo.ca974af3.png";